/**
 * BaseTool - Abstract base class for all tools in MySpeedTools
 * 
 * This class provides common functionality and structure for all tools.
 * Each tool should extend this class and implement the required methods.
 */
export abstract class BaseTool {
  protected initialized: boolean = false;

  /**
   * Initialize the tool
   * This method is called when the tool is loaded
   */
  abstract init(): Promise<void> | void;

  /**
   * Cleanup and destroy the tool
   * This method is called when the tool is unloaded
   */
  abstract destroy(): void;

  /**
   * Get the tool name
   */
  abstract getToolName(): string;

  /**
   * Get the tool version
   */
  getVersion(): string {
    return '1.0.0';
  }

  /**
   * Check if the tool is initialized
   */
  isInitialized(): boolean {
    return this.initialized;
  }

  /**
   * Set initialized state
   */
  protected setInitialized(state: boolean): void {
    this.initialized = state;
  }
}
